// @ts-ignore vendored blocksuite reference
/// <reference types="@blocksuite/affine-shared/commands" />
import type {
  BlockComponent,
  Command,
  InitCommandCtx,
} from '@blocksuite/block-std';

import { isPeekable, peek } from './peekable.js';

const getSelectedPeekableBlocks = (cmd: InitCommandCtx) => {
  // @ts-ignore vendored code - command chain extensions not visible with node module resolution
  const [result, ctx] = cmd.std.command
    .chain()
    // @ts-ignore vendored code - command chain extensions not visible with node module resolution
    .tryAll((chain: unknown) => [(chain as { getTextSelection: () => unknown }).getTextSelection(), (chain as { getBlockSelections: () => unknown }).getBlockSelections()])
    // @ts-ignore vendored code - command chain extensions not visible with node module resolution
    .getSelectedBlocks({ types: ['text', 'block'] })
    .run();
  return ((result ? ctx.selectedBlocks : []) || []).filter(isPeekable);
};

// @ts-ignore vendored code - command type extensions not visible with node module resolution
export const getSelectedPeekableBlocksCommand: Command<
  'selectedBlocks',
  'selectedPeekableBlocks'
> = (ctx, next) => {
  const selectedPeekableBlocks = getSelectedPeekableBlocks(ctx);
  if (selectedPeekableBlocks.length > 0) {
    next({ selectedPeekableBlocks });
  }
};

// @ts-ignore vendored code - command type extensions not visible with node module resolution
export const peekSelectedBlockCommand: Command<'selectedBlocks'> = (
  ctx,
  next
) => {
  const peekableBlocks = getSelectedPeekableBlocks(ctx);
  // if there are multiple blocks, peek the first one
  const block = peekableBlocks.at(0);

  if (block) {
    peek(block);
    next();
  }
};

declare global {
  namespace BlockSuite {
    interface CommandContext {
      selectedPeekableBlocks?: BlockComponent[];
    }

    interface Commands {
      peekSelectedBlock: typeof peekSelectedBlockCommand;
      getSelectedPeekableBlocks: typeof getSelectedPeekableBlocksCommand;
      // todo: add command for peek an inline element?
    }
  }
}
